module.exports = __webpack_public_path__ + "img/wp-new-habit-card1.e5f99917.jpg";